import { render, staticRenderFns } from "./LiveStageNG.vue?vue&type=template&id=bf4a266a&scoped=true&"
import script from "./LiveStageNG.vue?vue&type=script&lang=js&"
export * from "./LiveStageNG.vue?vue&type=script&lang=js&"
import style0 from "./LiveStageNG.vue?vue&type=style&index=0&id=bf4a266a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4a266a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDialog,VIcon,VProgressCircular})
